( function( app ) {
  const COMPONENT = {
    init: function() {
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'fancy-content-accordion', COMPONENT );
} )( app );
